export default {
  title: 'Webhook-signeringshemmelighed',
  warning: 'Gem denne hemmelighed nu — den vises ikke igen. Brug den til at verificere headeren X-Webhook-Signature.',
  done: 'Færdig',
};
